import { v4 as uuidv4 } from "uuid";

let sessionCorrelationId: string | null = null;

export function getCorrelationId(): string {
  if (!sessionCorrelationId) {
    sessionCorrelationId = uuidv4();
  }
  return sessionCorrelationId;
}

export function resetCorrelationId(): string {
  sessionCorrelationId = uuidv4();
  return sessionCorrelationId;
}
